import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import getApplicationServices from 'services/getApplicationServices'
import { InfoBox } from 'components/message-boxes/information-box/InformationBox'

const CreditDecisonRunning = () => {
	const { t } = useTranslation()

	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext
	)
	const applicationId = loanApplication.applicationData?.loanNumber!
	
	useEffect(() => {
		const interval = setInterval(async () => {
			await getApplicationInformation(applicationId);
		}, 5000);
		return () => clearInterval(interval);
	  }, []);
	
	const getApplicationInformation = async (applicationId: number) => {
		try {
			await getApplicationServices
				.GetApplicationInformation(applicationId, t)
				.then((response) => {
					loanApplication.setApplicationData(response)
				})
		} catch (error) {
			console.warn(error)
		}
	}

	return (
		<div
			className={`credit-decision-running`}>
				<CircleSpinner></CircleSpinner>	
				<InfoBox
					infoType='info'
					message={t('CreditDecisionRunningMessage')}
				/>
		</div>
	)
}

export default CreditDecisonRunning
